import { SecurityQuestionsVerifyClass } from '../../components/descope-security-questions-verify/SecurityQuestionsVerifyClass';
import { refs } from './inputWrapper';

export const vars = SecurityQuestionsVerifyClass.cssVarList;

const securityQuestionsVerify = {
  [vars.hostWidth]: 'min-content',
  [vars.questionCursor]: 'pointer',
  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
  [vars.questionFontSize]: refs.fontSize,
  [vars.questionFontFamily]: refs.fontFamily,
};

export default securityQuestionsVerify;
